import { useState, useEffect, useCallback } from 'react';
import { getErrorMessage } from '../utils/errorHandler';

/**
 * Hook para GET requests con auto-fetch.
 */
export function useFetch(apiFunction, params = null, autoFetch = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(autoFetch);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = params ? await apiFunction(params) : await apiFunction();
      setData(response.data?.data ?? response.data);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [apiFunction, params]);

  useEffect(() => {
    if (autoFetch) {
      fetchData();
    }
  }, [autoFetch, fetchData]);

  return { data, loading, error, refetch: fetchData };
}

/**
 * Hook para POST/PUT/DELETE requests (mutaciones).
 */
export function useMutation(apiFunction) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(async (payload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiFunction(payload);
      setData(response.data?.data ?? response.data);
      return response.data;
    } catch (err) {
      const message = getErrorMessage(err);
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [apiFunction]);

  return { mutate, data, loading, error };
}
